// deno-fmt-ignore-file
import { Array, IsArray } from '../types/array.mjs';
import { ExtendsRight } from './extends-right.mjs';
import { ExtendsLeft } from './extends-left.mjs';
export function ExtendsArray(inferred, left, right) {
    return (IsArray(right)
        ? ExtendsLeft(inferred, left, right.items)
        : ExtendsRight(inferred, Array(left), right));
}
